import React, { Component } from 'react';
import Lottie from "lottie-react";
import { Link, Redirect } from 'react-router-dom'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Container, Row, Col, ListGroup, Dropdown } from 'react-bootstrap';
import back from '../../assets/img/icons/back.svg'
import locations from '../../assets/img/people/location.svg'
import work from '../../assets/img/people/work.svg'
import educations from '../../assets/img/people/education.svg'
import more from '../../assets/img/icons/more.svg'
import dislike from '../../assets/img/people/dislike.svg'
import superlike from '../../assets/img/people/superlike.svg'
import like from '../../assets/img/people/like.svg'
import dislikejson from '../../assets/json/dislike.json'
import likejson from '../../assets/json/likejson.json'
import SuperLikePlan from '../commoncomponents/superlikeplan';
import heartmatch from '../../assets/img/people/heartmatch.svg';
import axios from 'axios';
import ls from "local-storage";
import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
import PaymentPending from '../main/plan/paymentpending';
import { Trans } from "react-i18next";   
import "../../config/i18n";
import { withTranslation } from "react-i18next";

class PeopleDetail extends Component {
    constructor(props) {
        super(props);
        this.SetReport = this.SetReport.bind(this);
        this.Message = this.Message.bind(this);
        this.state = {
            currentSlideIndex: 0,
            showDisLikeLottie: false,
            showLikeLottie: false,
            profile_userid:'',user_details:'',image:[],
            user_languages:[],interest:[],languages: [],
            paymentpendingmodal: false,
            matches: '',
            langKey: ls.get('LangValue'),
            api_url:localStorage.getItem('api_url'),
        };
    }

    componentDidMount() {
        if (this.props.i18n.language === 'ar' || this.props.i18n.language === 'he') {
            document.body.dir = 'rtl';
            document.body.classList.add('rtl');
            document.body.classList.remove('ltr')
        } else {
            document.body.dir = 'ltr';
            document.body.classList.remove('rtl');
            document.body.classList.add('ltr');
        }
        
        const apiUrl = localStorage.getItem('api_url');
        const { match: { params } } = this.props;
        var profile = new FormData();
        profile.append('user_id',JSON.parse(localStorage.getItem('session_userid')));
        profile.append('friend_id', params.userId);
        profile.append('language', this.state.langKey);  
        axios({
            method: 'post',
            url: apiUrl+'webprofilenew',
            data: profile,
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        }).then(res => {
            const user_details = res.data.result;
            if( res.data.status === "true"){
                if(user_details.report === "false"){
                    this.setState({ report: "Report User"});
                }else{
                    this.setState({ report: "UnReport User"});
                }
                this.setState({
                    user_details: user_details,
                    profile_userid: user_details.user_id,
                    image: user_details.imagess,
                    interest: user_details.interest_other,
                    languages: user_details.language_other,
                    religion: user_details.religion_other,
                });

                var visitprofile = new FormData();
                visitprofile.append('visit_user_id',params.userId);
                visitprofile.append('language', this.state.langKey);  
                visitprofile.append('user_id', JSON.parse(localStorage.getItem('session_userid')));
                axios({
                    method: 'post',
                    url: this.state.api_url+'webvisitprofile',
                    data: visitprofile,
                    config: { headers: {'Content-Type': 'multipart/form-data' }}
                })
            }
        }).catch(error => { 
            this.setState({ loginpage: true });
            //this.props.history.push("/login"); 
        });
    }

    SetReport(e) {
        const apiUrl = localStorage.getItem('api_url');
        var report = new FormData();
        report.append('user_id',JSON.parse(localStorage.getItem('session_userid')));
        report.append('report_user_id',this.state.profile_userid);
        report.append('language', this.state.langKey); 
        axios({
            method: 'post',
            url: apiUrl+'webreport',
            data: report,
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        }).then(res => {
            const message = res.data.message;
            if(this.state.report === "Report User"){
                this.setState({ 
                    report: "UnReport User",
                    successMessage: message,
                    suc_cls: 'successMsg floatingAlerts1'
                });
            }else{
                this.setState({ 
                    report: "Report User",
                    successMessage: message,
                    suc_cls: 'successMsg floatingAlerts1'
                });    
            }
            setTimeout(() => {
                this.setState({
                    suc_cls: 'successMsghide'
                });
            }, 5000); 
        }).catch(error => { 
            this.setState({ loginpage: true });
            //this.props.history.push("/login"); 
        });
    }

    handleSlideChange = index => {
        this.setState({ currentSlideIndex: index });
    };

    toggleDisLikeLottie = (user_id) => {
        const apiUrl = localStorage.getItem('api_url');
        var match = new FormData();
        match.append('user_id',JSON.parse(localStorage.getItem('session_userid')));
        match.append('follow_id', user_id);
        match.append('language', 'en'); 
        
        axios.defaults.headers.common['Authorization'] = JSON.parse(localStorage.getItem('session_token'));
        axios({
            method: 'post',
            url: apiUrl+'webunmatch',
            data: match,
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        }).then(res => {
            const message = 'Successfully Unfollowed';
            this.setState({ 
                successMessage: message,
                suc_cls: 'successMsg floatingAlerts1'
            });
            this.setState(prevState => ({
                showDisLikeLottie: !prevState.showDisLikeLottie
            }));
            setTimeout(() => {
                this.setState({
                    suc_cls: 'successMsghide'
                });
                this.setState({ people: true });
            }, 5000);
            
            // window.location.reload();   
        }) 
    }

    toggleLikeLottie = (user_id, reqType) => {
        const apiUrl = localStorage.getItem('api_url');
        var match = new FormData();
        match.append('user_id',JSON.parse(localStorage.getItem('session_userid')));
        match.append('follow_id', user_id);
        match.append('type', reqType);  
        match.append('language', this.state.langKey);
        axios.defaults.headers.common['Authorization'] = JSON.parse(localStorage.getItem('session_token'));
        axios({
            method: 'post',
            url: apiUrl+'webmatch',
            data: match,
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        }).then(res => { 
            const message = res.data.message;
            if(res.data.status === "true") {  
                this.setState(prevState => ({
                    showLikeLottie: !prevState.showLikeLottie
                }));
                this.setState({
                    matches: ''   
                });
                if(res.data.match === "1") {
                    this.setState({ 
                        matches: res.data.result   
                    }); 
                    this.setState({ send_message: true });
                }
                this.setState({ 
                    successMessage: message,
                    suc_cls: 'successMsg floatingAlerts1'
                }); 
                setTimeout(() => {
                    this.setState({
                        suc_cls: 'successMsghide'
                    });
                    this.setState({ people: true });
                }, 5000); 
            } else { 
                if(res.data.superlike_cashpayment === '1') {
                    this.handlePaymentPendingOpenModal();
                } else if(reqType === "superlike" && res.data.superlike_count === "0") { 
                    this.setState({ superlikeplanmodal: true });
                } else {
                    this.setState({ 
                        successMessage: message,
                        suc_cls: 'successMsg floatingAlerts1'
                    });

                    setTimeout(() => {
                        this.setState({
                            suc_cls: 'successMsghide'
                        });
                        this.setState({ people: true });
                    }, 5000);   
                }  
            } 
        })
    }

    Message() { 
        const apiUrl = localStorage.getItem('api_url');
        var report = new FormData();
        report.append('sender_id',JSON.parse(localStorage.getItem('session_userid')));
        report.append('receiver_id',this.state.profile_userid);
        report.append('language', this.state.langKey); 
        axios({
            method: 'post',
            url: apiUrl+'webcreatchat',
            data: report,
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        }).then(res => {
            this.setState({ MessageNew: true , chatid: res.data.chatid});
            //this.props.history.push(`/app/Message/MessageNew/${this.state.profile_userid}/${chatid}`)
        })

    }

    handleSuperLikePlanOpenModal = () => {
        this.setState({ superlikeplanmodal: true });
    }

    handleSuperLikePlanCloseModal = () => {
        this.setState({ superlikeplanmodal: false });
    }

    handlePaymentPendingOpenModal = () => {
        this.setState({ paymentpendingmodal: true });
    }

    handlePaymentPendingCloseModal = () => {
        this.setState({ paymentpendingmodal: false });
    }

    closeModal(tabId) {
        this.setState({
            [tabId]: false
        });
    }

    render() {

        if (this.state.loginpage) {
            return <Redirect to="/" />;
        }
        if (this.state.people) {
            return <Redirect to="/people" />;
        }
        if (this.state.MessageNew) {
            const url = `/message/${this.state.profile_userid}/${this.state.chatid}`;
            return <Redirect to={url} />;
        }

        const { showDisLikeLottie, showLikeLottie, interest } = this.state;

        const { t } = this.props;

        const settings = {
            dots: true,
            infinite: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            afterChange: this.handleSlideChange
        };

        return (

            <>
                <section className='common_layout overlow_x'>
                    <div className='whole_information'>
                        {this.state.successMessage && (
                            <div className={this.state.suc_cls}>
                                {this.state.successMessage}
                            </div>
                        )}
                    </div>
                    <div className='back_div'>
                        <Link to='/people'>
                            <img src={back} alt="img" />
                        </Link>
                    </div>
                    <div className='mt_1'>
                        <Container>
                            <div className='detail_card'>
                                <Container>
                                    <Row>
                                        <Col md={7}>
                                            <Slider {...settings}>
                                                {this.state.image.map((image, index) => (
                                                    <div>
                                                        <div key={index} className='slider_img'>
                                                            <img src={image} alt="img" />
                                                            <div className='dislikes_lottie'>
                                                                {showDisLikeLottie ? <Lottie animationData={dislikejson} className='dislikes_lottieplayer' /> : null}
                                                            </div>
                                                            <div className='likes_lottie'>
                                                                {showLikeLottie ? <Lottie animationData={likejson} className='likes_lottieplayer' /> : null}
                                                            </div>
                                                        
                                                        </div>
                                                    </div>
                                                ))}
                                            </Slider>
                                        </Col>
                                        <Col md={5}>

                                            <div className='slider_content'>
                                                <div>
                                                    <div className='slider_wholeH'>
                                                        <div className='slider_title_head'>
                                                            {this.state.user_details.age !== '' ? (<h4 className='slider_title'>{this.state.user_details.user_name}, {this.state.user_details.age}</h4>) : (<h4 className='slider_title'>{this.state.user_details.user_name}</h4>)}
                                                            <div className='more'>
                                                                <Dropdown>
                                                                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                                                                        <img src={more} alt="img" />
                                                                    </Dropdown.Toggle>
                                                                    <Dropdown.Menu>
                                                                        <Dropdown.Item onClick={this.SetReport} value={this.state.user_details.user_id}>{t(this.state.report)}</Dropdown.Item>
                                                                    </Dropdown.Menu>
                                                                </Dropdown>
                                                            </div>
                                                        </div>
                                                        <div className='slider_subdetails_div'>
                                                            {this.state.user_details.show_location === 'false' && (
                                                                <div className='slider_subdetails'>
                                                                    <img src={locations} alt="img" />
                                                                    <p>{this.state.user_details.location}</p>
                                                                </div>
                                                            )}
                                                            {this.state.user_details.school !== '' && (
                                                                <div className='slider_subdetails'>
                                                                    <img src={educations} alt="img" />
                                                                    <p>{this.state.user_details.school}</p>
                                                                </div>
                                                            )}
                                                            {this.state.user_details.job !== '' && (
                                                                <div className='slider_subdetails'>
                                                                    <img src={educations} alt="img" />
                                                                    <p>{this.state.user_details.job}</p>
                                                                </div>
                                                            )}
                                                            {this.state.user_details.company !== '' && (
                                                                <div className='slider_subdetails'>
                                                                    <img src={work} alt="img" />
                                                                    <p>{this.state.user_details.company}</p>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className='slider_subtitle'>
                                                            {this.state.religion !== '' && (
                                                                <>
                                                                    <h4><Trans i18nKey="Religion">Religion</Trans> :</h4>
                                                                    <p>{this.state.religion}</p>
                                                                </>
                                                            )}
                                                        </div>
                                                        <div className='slider_subtitle'>
                                                            {this.state.user_details.bio !== '' && (
                                                                <>
                                                                    <h4><Trans i18nKey="Biography">Biography</Trans> :</h4>
                                                                    <p>{this.state.user_details.bio}</p>
                                                                </>
                                                            )}
                                                        </div>
                                                        <div className='slider_subtitle'>
                                                            <h4><Trans i18nKey="Language">Language</Trans> :</h4>
                                                            <p>{this.state.languages && this.state.languages.join(', ')}</p>
                                                        </div>
                                                        {interest.length > 0 && (
                                                            <div className='slider_subtitle'>
                                                                <h4><Trans i18nKey="Interests">Interests</Trans>:</h4>
                                                                <div className='slider_list'>
                                                                    <div className='sliderlist_height'>
                                                                        <ListGroup>
                                                                            {interest.map((item, index) => (
                                                                                <ListGroup.Item key={index}>{item}</ListGroup.Item>
                                                                            ))}
                                                                        </ListGroup>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className='people_likes'>
                                                        <img src={dislike} alt='img' className='peoplelike_img'  onClick={() => this.toggleDisLikeLottie(this.state.user_details.user_id)} />
                                                        <img src={superlike} alt='img' className='peoplesuperlike_img' onClick={() => this.toggleLikeLottie(this.state.user_details.user_id, 'superlike')}/>
                                                        <img src={like} alt='img' className='peoplelike_img' onClick={() => this.toggleLikeLottie(this.state.user_details.user_id, 'like')} />
                                                    </div>
                                                </div>

                                            </div>
                                        </Col>
                                    </Row>
                                </Container>
                            </div>
                        </Container>
                    </div>
                </section>

                <SuperLikePlan
                    showModal={this.state.superlikeplanmodal}
                    handleClose={this.handleSuperLikePlanCloseModal}
                />

                <Modal isOpen={this.state.send_message} toggle={this.closeModal.bind(this, 'send_message')} className="modal_div matchmodal" centered>
                <ModalHeader toggle={this.closeModal.bind(this, 'send_message')}></ModalHeader>
                <ModalBody>
                    <div>
                        <div className='matchmodal_img'>
                            <div className='matchmodal_div'>
                                <img src={this.state.matches.loguser_image} alt='img' />
                            </div>
                            <div className='matchcenter'>
                                <img src={heartmatch} alt='img' />
                            </div>
                            <div className='matchmodal_div'>
                                <img src={this.state.matches.frienduser_image} alt='img' />
                            </div>
                        </div>
                        <div className='matchmodal_section'>
                            <h4><Trans i18nKey="It's Match!">It's Match!</Trans></h4>
                            <p><Trans i18nKey="You and">You and</Trans> {this.state.user_details.user_name} <Trans i18nKey="Like Each Other!">Like Each Other!</Trans></p>
                        </div>
                        <div className='matchmodalbtn'>
                            <Button onClick={this.Message.bind(this, this.state.matches.frienduser_id)}><Trans i18nKey="Send message">Send message</Trans></Button>
                        </div>
                    </div>
                </ModalBody>
                </Modal>
                
                <PaymentPending
                    showModal={this.state.paymentpendingmodal}
                    handleClose={this.handlePaymentPendingCloseModal}
                />
            </>
        );
    }
}

export default withTranslation("translations")(PeopleDetail);
